//Important react deps
import React from "react";

//Importing the context
import { UserAuth } from "../../Context/AuthContext";

//Importing the Link
import { Link, useNavigate } from "react-router-dom";

//Toasts
import { ToastContainer, toast } from "react-toastify";

//Styled Components
import {
  BottomDiv,
  BottomRightBox,
  BottomRightContainer,
  Box,
  Container,
  DateContainer,
  EmailContainer,
  LeftSide,
  RightBox,
  RightSide,
  TopDiv,
  TopRightBox,
  TopRightContainer,
  UserIconContainer,
  UserPicContainer,
  Username,
  UsernameContainer,
} from "./DashboardStyles";

//Importing the Icons
import { RandIcon } from "./Utils/RandomIcons";
import Sidebar from "./Components/Navigation/Sidebar";
import TopInfo from "./Components/TopInfo/TopInfo";

export default function Dashboard() {
  //Checking to see is the auth context works
  const { user, logout, username } = UserAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success("You have been logged out");
      navigate("/");
      console.log("You are logged out");
    } catch (e) {
      console.log(e.message);
      toast.error("Error logging out");
    }
  };

  // The current date
  const currentDate = new Date();
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  return (
    <>
      <Container>
        <Box>
          <LeftSide>
            <Sidebar />
          </LeftSide>
          <RightSide>
            <TopInfo />
          </RightSide>
        </Box>
      </Container>
    </>
  );
}
